import { render, staticRenderFns } from "./ShowCard.vue?vue&type=template&id=bb986222&scoped=true&"
import script from "./js/showCard.js?vue&type=script&lang=js&"
export * from "./js/showCard.js?vue&type=script&lang=js&"
import style0 from "./ShowCard.vue?vue&type=style&index=0&id=bb986222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb986222",
  null
  
)

export default component.exports